// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__Uo3JT","title":"FrontImage_title__1HeZ0"};